const inputValidatePublicCode = value => {
  if (value.length === 0) {
    return 'Obrigatório informar o código de vínculo'
  }

  if (value.length < 10) {
    return 'O código de vínculo não pode ter menos do que 10 caracteres'
  }

  if (value.length > 10) {
    return 'O código de vínculo não pode ter mais do que 10 caracteres'
  }

  if (value.match(/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/)) {
    return 'O código de vínculo não deve conter caracteres especiais'
  }
  return false
}

export { inputValidatePublicCode }
